export type NavChild = {
  label: string;
  href: string;
  description: string;
  icon: "vps" | "dedicated" | "cloud" | "email" | "security";
};

export type NavGroup = {
  heading: string;
  items: NavChild[];
};

export const productMegaMenu: NavGroup[] = [
  {
    heading: "Compute",
    items: [
      { label: "VPS Hosting", href: "/vps-hosting", description: "Configurable virtual servers for websites and apps.", icon: "vps" },
      { label: "Dedicated Servers", href: "/dedicated-servers", description: "Full server resources for demanding workloads.", icon: "dedicated" },
      { label: "Cloud Solutions", href: "/cloud-solutions", description: "Flexible cloud infrastructure that scales with you.", icon: "cloud" },
    ],
  },
  {
    heading: "Communication",
    items: [
      { label: "Business Email", href: "/email-solutions", description: "Professional mailboxes built for modern teams.", icon: "email" },
    ],
  },
  {
    heading: "Infrastructure Protection",
    items: [
      { label: "Security & Network", href: "/security-network", description: "Firewall, monitoring and access solutions.", icon: "security" },
    ],
  },
];

export const primaryNav = [
  { label: "Products", href: "/#products", hasMegaMenu: true },
  { label: "Solutions", href: "/#solutions" },
  { label: "Why The Planet", href: "/#why-the-planet" },
  { label: "About", href: "/about" },
  { label: "Resources", href: "/support" },
  { label: "Contact", href: "/contact" },
] as const;

export const footerNav = {
  products: [
    { label: "VPS Hosting", href: "/vps-hosting" },
    { label: "Dedicated Servers", href: "/dedicated-servers" },
    { label: "Cloud Solutions", href: "/cloud-solutions" },
    { label: "Business Email", href: "/email-solutions" },
    { label: "Security & Network", href: "/security-network" },
  ],
  company: [
    { label: "About Us", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "Support", href: "/support" },
    { label: "Client Area", href: "whmcs:login" },
  ],
  resources: [
    { label: "Knowledge Base", href: "whmcs:support", editableNote: "Link until a public KB exists" },
    { label: "Service Status", href: "#", editableNote: "Add once a status page exists" },
    { label: "Documentation", href: "#", editableNote: "Add once docs exist" },
    { label: "Product Catalogue", href: "whmcs:store" },
  ],
  legal: [
    { label: "Privacy Policy", href: "/legal/privacy-policy" },
    { label: "Terms and Conditions", href: "/legal/terms-and-conditions" },
    { label: "Acceptable Use Policy", href: "/legal/acceptable-use-policy" },
    { label: "Service Level Agreement", href: "/legal/service-level-agreement" },
    { label: "Refund Policy", href: "/legal/refund-policy" },
  ],
} as const;
